import { useEffect, useMemo, useState } from 'react';
import { Protocol } from '../../types/sharedTypeImpl.ts';
import { ModalDialog } from '../modalDialog.tsx';
import { ProtocolPdf } from '../protocol-pdf/protocolPdf.tsx';
import { VisualInspectionImage } from '../visualInspectionImage.tsx';
import { ProtocolPositionsTable } from './protocolPositionsTable.tsx';
import { useLoadProtocol } from './useLoadProtocol.ts';


interface Props {
    protocol?: Protocol | undefined;
    product?: string | undefined;
    initialPositionIdx: number | null;
    show: boolean;
    onClose: () => void;
}

export function ProtocolPreviewDialog({
    protocol: protocolInput,
    product,
    initialPositionIdx,
    show,
    onClose
}: Props) {

    const [activePositionIdx, setActivePositionIdx] = useState<number | null>(initialPositionIdx);

    const {
        protocol,
        pdfFetch,
        positionImages,
    } = useLoadProtocol(protocolInput, product);


    useEffect(() => {
        setActivePositionIdx(initialPositionIdx);
    }, [initialPositionIdx]);

    const selectedPosition = activePositionIdx != null
        ? protocol?.positions[activePositionIdx]
        : null;

    const positionSelection = useMemo(() =>
        activePositionIdx != null ? { positionIdx: activePositionIdx } : null,
        [activePositionIdx]
    );

    const visiblePositionIds = new Set(protocol?.positions.map(position => position.id) ?? []);

    return (
        <ModalDialog
            isOpen={show}
            frameStyle={{ width: '80%', margin: '2% auto', }}
            contentStyle={{ height: '100%' }}
            cancelOnOutsideClick={true}
            onCancel={onClose}
        >
            <div style={{ display: 'flex', flexDirection: 'row', height: '100%', gap: '10px' }}>
                <ProtocolPdf
                    className='measurement-pdf-container'
                    style={{ flex: 1, height: '85vh' }}
                    isViewMode={true}
                    positions={protocol?.positions}
                    visiblePositionIds={visiblePositionIds}
                    positionSelection={positionSelection}
                    showAllMarkers={false}
                    pdfContent={pdfFetch.data ?? null}
                    isPdfLoading={pdfFetch.isLoading}
                />
                <div style={{ width: '380px', height: '85vh', display: 'flex', flexDirection: 'column' }} >
                    <div style={{ overflowY: 'scroll' }}>
                        <ProtocolPositionsTable
                            protocol={protocol}
                            activePositionIdx={activePositionIdx}
                            setActivePositionIdx={setActivePositionIdx}
                        />
                    </div>

                    {selectedPosition?.type === 'visualInspection' &&
                        <VisualInspectionImage
                            style={{ marginTop: '8px' }}
                            className='measurement-form-bottom'
                            imageData={positionImages.get(selectedPosition.positionNumber)}
                            isViewMode={true}
                        />
                    }
                </div>
            </div>
        </ModalDialog>
    );
}
